import { devWarn } from '../utils/developmentDiagnostics';
/**
 * Observe only signed-in status. Firebase is loaded after mounting in the browser,
 * never while generating public HTML; no account or billing data is returned.
 * @param {(state: 'unknown' | 'signed-in' | 'signed-out') => void} onChange
 * @returns {() => void}
 */
export function subscribeToPublicSession(onChange) {
  if (typeof window === 'undefined') {
    return () => {
      /* No browser observer exists during static rendering. */
    };
  }
  let disposed = false;
  let unsubscribe;
  const unavailable = () => {
    if (disposed) {
      return;
    }
    onChange('unknown');
    devWarn('Public sign-in status is unavailable.');
  };
  // Keep extensionless split imports in JS, as in ReaderEntry.js, for CRA's
  // Webpack resolver alongside the project's legacy NodeNext TypeScript config.
  void Promise.all([import('../firebase'), import('firebase/auth')])
    .then(([{ auth }, { onAuthStateChanged }]) => {
      if (disposed) {
        return;
      }
      unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
          if (!disposed) {
            onChange(user ? 'signed-in' : 'signed-out');
          }
        },
        unavailable,
      );
    })
    .catch(unavailable);
  return () => {
    disposed = true;
    unsubscribe?.();
  };
}
